<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import ImportFileStepper from '@/components/common/ImportFileStepper.vue'
import SoilTypesTable from '@/components/soil-type/SoilTypesTable.vue'

const props = defineProps({
  dialog: {},
  storeNamespace: {}
})

const emit = defineEmits(['update:dialog'])

const store = useStore()

const options = computed(() => store.state.baseSoilType.options)
const importItems = computed(() => store.state.baseSoilType.importItems)
const items = computed(() => importItems.value.map((item) => item.soil_type))

const editableDialog = computed({
  get() {
    return props.dialog
  },
  set(value) {
    emit('update:dialog', value)
  }
})
</script>

<template>
  <v-dialog v-model="editableDialog" max-width="85%">
    <ImportFileStepper
      @close-dialog="editableDialog = false"
      :storeNamespace="storeNamespace"
      text="soil types"
    >
      <template v-slot>
        <v-lazy>
          <SoilTypesTable
            v-if="options"
            :base-items="importItems"
            :items="items"
            :editable="false"
          />
        </v-lazy>
      </template>
    </ImportFileStepper>
  </v-dialog>
</template>
